import React from 'react';
import { Subscribe as Sub } from 'unstated';
import app from 'src/feathers';

// This component simply wraps the Unstate Sububscribe component
// and adds a default to prop and provides a render prop instead
// of function as a child bc it is cleaner
export default ({ to = [app.get('stateContainer')], render }) => {
  return <Sub to={to} children={render} />;
};
